module.exports = __webpack_public_path__ + "static/Murphy_confidentiality_fee_agreement-46dcdbe6045c1612cce71e75052f2c7e.pdf";